import { Loader2, CheckCircle2, Send } from 'lucide-react';
import Ayuda from '../ui/Ayuda';
import { GRAVEDADES } from './gravedad';

/* =====================================================================
   El formulario de «Reportar un problema» · DIRECTRIZ-TICKETS F2
   =====================================================================
   Presentacional a propósito: no sabe si va dentro de un modal (con
   cuenta) o en la página pública del QR (sin cuenta). Pide lo mínimo —qué
   pasa y qué tan grave es— con objetivos táctiles grandes para el teléfono
   (M2/M9 del loop móvil: todo se toca con el pulgar a una mano).

   Cuando el reporte se envió, muestra el folio: toda acción confirma
   visiblemente que ocurrió (usuario cero, punto 7).
   ===================================================================== */
export default function FormularioReporte({
  descripcion,
  onDescripcion,
  gravedad,
  onGravedad,
  enviando = false,
  error = '',
  folio = '',
  onEnviar,
}) {
  // Enviado: la confirmación con el folio y nada más que estorbe.
  if (folio) {
    return (
      <div className="flex flex-col items-center gap-3 py-6 text-center">
        <div className="rounded-2xl bg-green-100 p-4">
          <CheckCircle2 className="h-8 w-8 text-green-700" aria-hidden="true" />
        </div>
        <p className="text-lg font-semibold text-gray-900">Tu reporte se envió</p>
        <p className="text-sm text-gray-600">
          Guarda este folio para dar seguimiento:
        </p>
        <p className="rounded-lg bg-gray-100 px-4 py-2 font-mono text-lg font-bold text-gray-900">
          {folio}
        </p>
      </div>
    );
  }

  const puedeEnviar = descripcion.trim().length > 0 && !enviando;

  return (
    <div className="flex flex-col gap-5">
      {/* QUÉ PASA */}
      <div>
        <label htmlFor="reporte-que-pasa" className="block font-medium text-gray-900">
          ¿Qué está pasando?
        </label>
        <Ayuda id="reportar.que_pasa" />
        <textarea
          id="reporte-que-pasa"
          value={descripcion}
          onChange={(e) => onDescripcion(e.target.value)}
          rows={4}
          maxLength={8000}
          placeholder="Por ejemplo: la impresora de recepción no imprime, marca luz roja."
          className="mt-1 w-full rounded-xl border border-gray-300 p-3 text-base
                     focus:border-[var(--color-marca)] focus:outline-none
                     focus:ring-2 focus:ring-[var(--color-marca)]"
        />
      </div>

      {/* QUÉ TAN GRAVE · tres botones grandes, verde/amarillo/rojo */}
      <fieldset>
        <legend className="font-medium text-gray-900">¿Qué tan grave es?</legend>
        <div className="mt-2 flex flex-col gap-2">
          {GRAVEDADES.map((g) => {
            const activo = gravedad === g.clave;
            return (
              <button
                type="button"
                key={g.clave}
                aria-pressed={activo}
                onClick={() => onGravedad(g.clave)}
                className={`min-h-[56px] rounded-xl border px-4 py-3 text-left
                            transition ${activo ? g.tonoActivo : g.tono}`}
              >
                <span className="block font-semibold">{g.etiqueta}</span>
                <span className="block text-sm opacity-90">{g.detalle}</span>
              </button>
            );
          })}
        </div>
      </fieldset>

      {error && (
        <p role="alert" className="rounded-lg bg-red-50 p-3 text-sm text-red-800">
          {error}
        </p>
      )}

      {/* ENVIAR · deshabilitado CON la razón visible (usuario cero, punto 8) */}
      <div>
        <button
          type="button"
          disabled={!puedeEnviar}
          onClick={onEnviar}
          className="flex min-h-[52px] w-full items-center justify-center gap-2
                     rounded-xl bg-[var(--color-marca)] px-4 font-semibold text-white
                     disabled:cursor-not-allowed disabled:opacity-50"
        >
          {enviando
            ? <><Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" /> Enviando…</>
            : <><Send className="h-5 w-5" aria-hidden="true" /> Enviar reporte</>}
        </button>
        {!descripcion.trim() && !enviando && (
          <p className="mt-1 text-center text-xs text-gray-500">
            Escribe qué está pasando para poder enviar.
          </p>
        )}
      </div>
    </div>
  );
}
